exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.transfer-failed-footer {\n  font-size: 12px;\n  color: red;\n}\n.transfer-failed-footer:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}", "", {"version":3,"sources":["F:/workSpace/eclipse/branch/mcFroutendTemp/src/components/common/tabs/tabs_detailed_progress/tab_unfinished_detail.vue"],"names":[],"mappings":";AAAA;EACE,gBAAgB;EAChB,WAAW;CACZ;AAED;EACE,2BAA2B;EAC3B,gBAAgB;CACjB","file":"tab_unfinished_detail.vue","sourcesContent":[".transfer-failed-footer {\n  font-size: 12px;\n  color: red;\n}\n\n.transfer-failed-footer:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ea078ff8","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/tabs/tabs_detailed_progress/tab_unfinished_detail.vue
// module id = Zayb
// module chunks = 1